import { useUser } from "@/app/context/UserContext";
import React, { useState } from "react";
import { paramChatbotRequest } from "@/app/models/interfaceChatbotconversation";
import { getCookie } from "@/app/helpers/cookies";
import { chatbotSearch } from "@/app/services/chatbotsearch";
import InputChat from "../Elements/Core/InputChat";
import { Action } from "@/app/constants/enums";
import LinkChat from "../Elements/Core/LinkChat";
import { useConfig } from "@/app/context/ConfigContext";
import { getcurrentUser } from "@/app/helpers/functions";

 
 
type SearchResultItem = {
  [key: string]: string;
};
type Notification = {
  id: string;
  title: string;
  body: string;
  link: string;
  read: boolean
};
const ListDatacenterIndex = () => {
  const { baseUrl } = useConfig();
  const { user,userProject,myDocs,currentConversation,accessType} = useUser();// Accedemos al usuario logueado desde el contexto
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [searchLoading, setSearchLoading] = useState(false); 
  const [results, setResults] = useState<SearchResultItem[]>([]); // Ahora es una lista de objetos
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const [seenNotifications, setSeenNotifications] = useState<string[]>(() => {
    const stored = localStorage.getItem('seenNotifications');
    return stored ? JSON.parse(stored) : [];
  });
  const markAsSeen = (id: string) => {
    if (!seenNotifications.includes(id)) {
      const updated = [...seenNotifications, id];
      setSeenNotifications(updated);
      localStorage.setItem('seenNotifications', JSON.stringify(updated));
    }
  };

  const handleSearch = async (e: React.FormEvent) => {
    e.preventDefault(); 
    if (searchTerm.trim()) { 
      try {
        setSearchLoading(true); 
        const key_u = user.accessToken;
        const file_ids = userProject?.docs?.filter(doc=>doc.seleccionado)?.map(doc=>doc.file_id);
        const my_file_ids = myDocs?.filter(doc=>doc.seleccionado)?.map(doc=>doc.file_id);

        //const paramsSearch: paramChatbotRequest = {
        //  question: searchTerm,
        //  key_p: userProject.project.id?userProject.project.id:"",
        //  key_u: key_u?key_u:'',
        //  user_id: user ? user.email: getCookie('clientiditc'),
        //  base_url: window.location.origin,  //"https://playdev2-inca.web.app"        
        //  // file_ids: [], // Retornar
        //  // my_collection: "incaai-casa-andina-probando-excel", // Retornar
        //    // my_file_ids: ["H9WbDQ120qSg6vusyAO0"], // retornar
        //  file_ids: file_ids.length == 0 ?[]:file_ids,
        //  my_collection: user ? user.email: getCookie('clientiditc'),
        //  my_file_ids: my_file_ids?.length == 0 ?[]:my_file_ids,
        //  prompt_params:userProject?.config?.prompt_params,
        //  config_params:userProject?.config?.config_params,
        //  user_data: {
        //    user_id:user ? user.email: getCookie('clientiditc')
        //  },
        //  reload:false
        //};

         const paramsSearch: paramChatbotRequest = {
                  question: searchTerm,
                  key_p: userProject.project.id?userProject.project.id:'',
                  key_u: key_u?key_u:'',
                  user_id: getcurrentUser(accessType, userProject, user),
                  base_url: baseUrl,          
                  //file_ids: [], // Retornar
                  //my_collection: "fichas-tecnicas", // Retornar
                  //my_file_ids: ["H9WbDQ120qSg6vusyAO0"], // retornar
                  file_ids: file_ids.length == 0 ?[]:file_ids,
                  my_collection: getcurrentUser(accessType, userProject, user),
                  my_file_ids: my_file_ids?.length == 0 ?[]:my_file_ids,
                  prompt_params:userProject?.config?.prompt_params,
                  config_params:userProject?.config?.config_params,
                  user_data: {
                    user_id:getcurrentUser(accessType, userProject, user)
                  }, 
                  reload: false,
        
                  conversation_id:currentConversation?.conversation_id,
                  access_type:accessType,
                  attached_files:[],
                };
                
        
        const response = await chatbotSearch(paramsSearch); 
  
        setResults( response.documents.map((item:any) => item.document) ); 
 
      } catch (error) {
        console.error('Error obteniendo respuesta', error);
      }
      finally {
        setSearchLoading(false);
      } 
    } 
  };
    
  return (  
    <aside className="w-full h-full">
      <form onSubmit={handleSearch} className="mb-4">
        <label className="block text-gray-700 font-semibold mb-2" htmlFor="search">
          ¿Qué necesitas?
        </label>
        <InputChat
          actionCode={Action.RIGHT_SEARCH} 
          type="text"
          id="search"
          value={searchTerm}
          disabled={searchLoading}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Escribe aquí..."
          className={`w-full border n-fmr-input px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700`}
        /> 
      </form>

          {searchLoading?
          'Loading..': 
          results.length==0?'No result':
          results.map((result, index) => (

            <div key={index} className="p-4 border rounded-lg shadow-lg n-menu-content-list bg-white mb-4 animate-fadeIn">

              <h3 className="text-sm font-semibold text-gray-700 mb-2 uppercase "> 
                  {Object.entries(result).map(([key, value]) => ( 
                    key.toLowerCase().includes(('TITULO').toLowerCase())?value:'' 
                  ))} 
              </h3>
              
              <ul className="mt-2 text-gray-600">
                {Object.entries(result).map(([key, value]) => ( 
                  (key.toLowerCase().includes('TITULO'.toLowerCase()) ||
                    key.toLowerCase().includes('LINK'.toLowerCase()) ||
                    key.toLowerCase().includes('FECHA'.toLowerCase()) ||  
                    key.toLowerCase().includes('Id'.toLowerCase())? '' : 
                    <li key={key} className="text-sm mb-1">
                      <span className="font-semibold capitalize">{key}:</span>
                      <span> {value}</span>
                    </li>
                  ) 
                ))}
              </ul>
            <div className="flex justify-between mt-4">
              <div className="flex">
                {Object.entries(result).map(([key, value]) => (
                  key.toLowerCase().includes('fecha') && value && ( 
                    <div key={key} className="text-sm mb-1">
                      <span className="font-semibold capitalize">{key}:</span>
                      <span> {value}</span>
                    </div>
                  )
                ))}
              </div>

              <div className="flex">
                {Object.entries(result).map(([key, value]) => (
                  key.toLowerCase().includes('link') && value && ( 
                    <LinkChat 
                      key={key}
                      actionCode={Action.RIGHT_SEARCH_LINK} 
                      href={value} 
                      newTab={true}
                      className="capitalize text-xs mx-1 pl-3 pr-3 bg-blue-500 text-white py-1 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-700"
                    > 
                      {key}
                    </LinkChat>
                  )
                ))}
              </div>
            </div>
            </div>


          ))}
        
        <label className="block text-yellow-800 font-bold text-lg mt-8 mb-2" htmlFor="search">
          🔔 Notificaciones
        </label>
    
        {(userProject.project.notifications?.length ?? 0) === 0
          ? 'No tienes notificaciones'
          : userProject.project.notifications.map((notif, index) => {
            const isSeen = seenNotifications.includes(notif.id);
            return (
              <div
                key={notif.id}
                className={`p-4 border-l-4 rounded-md shadow-sm mb-4 animate-fadeIn ${
                  isSeen ? 'border-gray-300 bg-gray-100' : 'border-yellow-400 bg-yellow-50'
                }`}
                onMouseEnter={() => markAsSeen(notif.id)} // Marcar al pasar el mouse
              >
                <h3 className="text-sm font-bold mb-2 uppercase text-center flex items-center justify-center gap-2">
                  {notif.title}
                </h3>
                <ul className="mt-2 text-yellow-900">
                  <li className="text-sm italic mb-1 text-center">{notif.body}</li>
                </ul>
                <div className="flex justify-center mt-4">
                  {notif.link && (
                    <LinkChat
                      actionCode={Action.NOTIFICATION_LINK}
                      href={notif.link}
                      newTab={true}
                      onClick={() => markAsSeen(notif.id)} // También al hacer click
                      className="capitalize text-sm mx-1 px-4 py-1 bg-yellow-600 text-white rounded-full hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-all duration-200"
                    >
                      🔗 Ver notificación
                    </LinkChat>
                  )}
                </div>
              </div>
            );
          })}
    
        

      
    </aside> 
  );
};

export default ListDatacenterIndex;